import {BreadCrumb} from "primereact/breadcrumb";
import Icon from "../../system/components/icon";
import PageHeaderButton from "../components/page-header-button";
import {Button} from "primereact/button";
import {TabPanel, TabView} from "primereact/tabview";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslate} from "../../system/useTranslate";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useGoalComment} from "../../models/goal-comment/use-goal-comment";
import {useProject} from "../../models/project/use-project";
import Archive from "./tabs/archive";
import AccessControl from "./tabs/access-control";
import ManageMembers from "./tabs/manage-members";
import {usePermission} from "../../system/usePermission";
import ProfileSetting from "./tabs/profile-setting";
import Subscriptions from "./tabs/subscriptions";
import SelectableTabsButton, {useSelectableTabs} from "../components/selectable-tabs-button";
import WorkspaceSettings from "./tabs/workspace-settings";
import CrmConnection from "./tabs/crm-connection";
import WorkspacePortability from "./tabs/workspace-portability";
import {useWorkspaceRole} from "../../system/use-workspace-role";

function Index(props) {

    const [activeIndex,setActiveIndex] = useState(0);
    const [breadCrumb,setBreadCrumbData] = useState([]);
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const [createNodeDialogVisible, setCreateNodeDialogVisible] = useState(false);
    const [selectedGoalData, setSelectedGoalData] = useState();
    const [selectedProjectData, setSelectedProjectData] = useState();
    const [pending, setPending] = useState();
    const translate = useTranslate();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch()
    const goal = useGoalComment();
    const project = useProject();
    const permission = usePermission();
    const {role: workspaceRole} = useWorkspaceRole();
    const workspacePaymentPending = workspaceMembershipData?.workspace?.workspaceStatus === "payment_pending";

    const canAny = (...permissions) => permissions.some((value) => permission.can(value));
    const tabs = [
        { id: "user-profile", label: "profile", icon: "mi mi:account_circle", view:ProfileSetting },
        { id: "archive", label: "archive", icon: "mi mi:archive", view:Archive, visible:canAny("archive-project", "create-new-goals", "canManageTasks") },
        { id: "subscriptions", label: "subscription", icon: "mi mi:workspace_premium", view:Subscriptions, visible:permission.can("canManageBilling") },
        { id: "access-control", label: "access-control", icon: "mi mi:shield_lock", view:AccessControl, status: "disable", visible:permission.can("modify-access-control") },
        { id: "manage-members", label: "manage-members", icon: "mi mi:groups", view:ManageMembers, visible:permission.can("modify-workspace-members") },
        { id: "workspace-settings", label: "workspace-settings", icon: "mi mi:settings", view:WorkspaceSettings, visible:workspaceRole === "owner" },
        { id: "workspace-portability", label: "workspace-portability", icon: "mi mi:import_export", view:WorkspacePortability, visible:workspaceRole === "owner" },
        { id: "crm-connection", label: "crm-connection", icon: "mi mi:link", view:CrmConnection, visible:workspaceRole === "owner" },
    ].filter((tab) => tab.visible !== false);
    const selectableTabs = useSelectableTabs(tabs, "visible-tabs:settings", activeIndex, setActiveIndex);
    const visibleTabs = workspacePaymentPending
        ? [{id: "subscriptions", label: "subscription", icon: "mi mi:workspace_premium", view:Subscriptions}]
        : selectableTabs.visibleTabs;
    const {selectedIds, toggleTab} = selectableTabs;
    const requestedTab = searchParams.get("tab");
    const requestedTabIndex = visibleTabs.findIndex((tab) => tab.id === requestedTab);

    useEffect(() => {
        if (workspacePaymentPending) setActiveIndex(0);
    }, [workspacePaymentPending]);

    useEffect(() => {
        if (!requestedTab || workspacePaymentPending || requestedTabIndex < 0) return;
        setActiveIndex(requestedTabIndex);
    }, [requestedTab, requestedTabIndex, workspacePaymentPending]);

    useEffect(()=>{
        setBreadCrumbData([
            {label:translate("settings"), command:()=>{navigate("/settings")}}
        ]);
    },[]);

    return(
        <div className="h-full overflow-hidden flex flex-column">
            <BreadCrumb separatorIcon={<Icon icon="mi mi:chevron_left text-xs"/>} className="bg-transparent border-none text-xs" model={breadCrumb}/>
            <PageHeaderButton title={props.name} description={props.description} />
            {/* Settings tabs */}
            <div className="flex-1 min-h-0 flex flex-column relative">
                {!workspacePaymentPending && <SelectableTabsButton tabs={tabs} selectedIds={selectedIds} onChange={toggleTab} className="absolute z-5" style={{top: ".45rem", left: ".75rem"}}/>}
                <TabView lazy activeIndex={activeIndex} onTabChange={(e)=>{setActiveIndex(e.index);
                    setBreadCrumbData(prv=>{
                        const next = Array.isArray(prv) ? [...prv] : [];
                        next[1] = {label:translate(visibleTabs[e.index].label)};
                        return next;
                    });
                }} panelContainerClassName="flex-1 min-h-0 overflow-hidden p-0 border-noround" className="h-full flex flex-column">
                    {visibleTabs.map((tab, tabIndex) => {
                        const TabContent = tab.view;
                        return (
                        <TabPanel
                            key={tab.id}
                            header={translate(tab.label)}
                            disabled={tab.disabled}
                            leftIcon={<Icon icon={tab.icon} className="pl-2" />}
                            className="h-full text-xs">
                            {tabIndex === activeIndex && <div className="h-full min-h-0 overflow-auto">
                                <TabContent setGoalDialogVisible={setCreateNodeDialogVisible} setPending={setPending} />
                            </div>}
                        </TabPanel>
                    )})}
                </TabView>
            </div>
        </div>
    )
}



export default Index;
